import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const UpdateAssetBrandVoicePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "UpdateAssetBrandVoicePopup" */ './View'),
  'popup'
);
